import { QueryClient } from "@tanstack/react-query";

import { flocknoteKeys } from "Flocknote/API/keys";

const defaultQueryConfig = {
  staleTime: 5000,
  ...(process.env.NODE_ENV === "test" && { retry: false }),
};

export const queryClient = new QueryClient({
  defaultOptions: { queries: defaultQueryConfig },
});

// 🚀 everythingsourced from App state is assumed fresh
queryClient.setQueryDefaults(flocknoteKeys.all(), {
  staleTime: Infinity,
});
